import { render } from "./VuePagoPlux.vue?vue&type=template&id=41f3babe"
import script from "./VuePagoPlux.vue?vue&type=script&lang=js"
export * from "./VuePagoPlux.vue?vue&type=script&lang=js"

import "./VuePagoPlux.vue?vue&type=style&index=0&id=41f3babe&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__